const KEY_AUTH = 'auth';
const KEY_USER_ID = 'enterprise_mochipay_user_id';

export const getAuth = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY_AUTH));
  } catch (e) {
    return {};
  }
};

export const saveAuth = obj => {
  return sessionStorage.setItem(KEY_AUTH, JSON.stringify(obj));
};

export const getUserId = () => {
  return sessionStorage.getItem(KEY_USER_ID) || '';
};

export const saveUserId = id => {
  return sessionStorage.setItem(KEY_USER_ID, id);
};

export const clearStorage = () => {
  sessionStorage.clear();
};
